var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/types.ts
var Theme = class {
  name;
  colors;
  typography;
  shadows;
  spacings;
  radiuses;
  borderWidths;
  constructor({
    name,
    colors: colors2,
    typography: typography2,
    shadows: shadows2,
    spacings: spacings2,
    radiuses: radiuses2,
    borderWidths: borderWidths2
  }) {
    if (!name) throw new Error("You must provide a name to this theme");
    this.name = name;
    this.colors = colors2;
    this.typography = typography2;
    this.shadows = shadows2;
    this.spacings = spacings2;
    this.radiuses = radiuses2;
    this.borderWidths = borderWidths2;
  }
};

// src/themes/shared/borderWidths.ts
var borderWidths = {
  none: 0,
  sm: 1,
  rg: 2,
  lg: 4
};
var borderWidths_default = borderWidths;

// src/themes/shared/radiuses.ts
var radiuses = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 32,
  xxl: 64,
  rounded: 999
};
var radiuses_default = radiuses;

// src/themes/shared/shadows.ts
var color = "#002635";
var baseShadow = {
  shadowColor: color,
  shadowOpacity: 0.15,
  overflow: "visible"
};
var shadows = {
  sm: {
    ...baseShadow,
    elevation: 2,
    shadowOffset: {
      height: 2,
      width: 0
    },
    shadowRadius: 2,
    boxShadow: `0px 2px 2px 0px rgba(0,38,51,0.1)`
  },
  rg: {
    ...baseShadow,
    elevation: 6,
    shadowOffset: {
      height: 4,
      width: 0
    },
    shadowRadius: 4,
    boxShadow: `0px 4px 4px 0px rgba(0,38,51,0.1)`
  },
  md: {
    ...baseShadow,
    elevation: 8,
    shadowOffset: {
      height: 8,
      width: 0
    },
    shadowRadius: 8,
    boxShadow: `0px 8px 8px 0px rgba(0,38,51,0.1)`
  },
  lg: {
    ...baseShadow,
    elevation: 12,
    shadowOffset: {
      height: 16,
      width: 0
    },
    shadowRadius: 16,
    boxShadow: `0px 16px 16px 0px rgba(0,38,51,0.1)`
  }
};
var shadows_default = shadows;

// src/themes/shared/spacings.ts
var spacings = {
  none: 0,
  xs: 2,
  sm: 4,
  md: 8,
  lg: 16,
  xl: 24,
  "2xl": 32,
  "3xl": 48,
  "4xl": 64
};
var spacings_default = spacings;

// src/themes/shared/typography.ts
var typography = {
  families: {
    pm: "Inter",
    /** Font used to display numbers */
    numbers: "Inconsolata"
  },
  letterSpacings: {
    tighter: -0.05,
    tight: -0.025,
    normal: 0,
    wide: 0.025,
    wider: 0.05,
    widest: 0.1
  },
  /** Multiplier */
  lineHeights: {
    none: 1,
    xxs: 0.8,
    xs: 1,
    sm: 1.2,
    rg: 1.35,
    md: 1.4,
    lg: 1.45,
    xl: 1.5,
    xxl: 1.6
  },
  /** Pixels */
  sizes: {
    "2xs": 8,
    xs: 10,
    sm: 12,
    rg: 14,
    md: 16,
    lg: 20,
    xl: 24,
    "2xl": 32
  },
  weights: {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900
  }
};
var typography_default = typography;

// src/themes/shared/index.ts
var shared_exports = {};
__export(shared_exports, {
  borderWidths: () => borderWidths_default,
  metrics: () => metrics_default,
  radiuses: () => radiuses_default,
  shadows: () => shadows_default,
  spacings: () => spacings_default,
  typography: () => typography_default
});

// src/themes/shared/metrics.ts
var capacitive = {
  "200": "#F7D2A1",
  "500": "#ED9A2C",
  "800": "#BC7210"
};
var drainage = {
  "200": "#F14BA5",
  "500": "#990C58",
  "800": "#390421"
};
var evapotranspiration = {
  "200": "#D8EBF3",
  "500": "#7DBDD7",
  "800": "#44A0C5"
};
var electroConductivity = {
  "200": "#BDEFF5",
  "500": "#2BCDDE",
  "800": "#16828D"
};
var unassigned = {
  "200": "#000000",
  "500": "#000000",
  "800": "#000000"
};
var humidity = {
  "200": "#E3C7FF",
  "300": "#9947EB",
  "400": "#7A18DD",
  "500": "#5B12A4",
  "600": "#420D77",
  "700": "#29084A",
  "800": "#0F031C"
};
var hydricDeficit = {
  "200": "#50A2EC",
  "500": "#0B3A64",
  "800": "#03101C"
};
var hydricPotential = {
  "200": "#E1EAC7",
  "500": "#A6C157",
  "800": "#7D9537"
};
var irrigation = {
  "200": "#FFDFB8",
  "500": "#FF8C00",
  "800": "#B26200"
};
var leafWetness = {
  "200": "#B2FFF9",
  "500": "#00887E",
  "800": "#003D39"
};
var photosyntheticActiveRadiation = {
  "200": "#BEF4A4",
  "500": "#4CBB17",
  "800": "#30760F"
};
var rainfalls = {
  "200": "#C1E1FF",
  "300": "#71A8DB",
  "400": "#488FD1",
  "500": "#2E75B6",
  "600": "#2969A3",
  "700": "#1F4F7A",
  "800": "#0B3A64"
};
var soilWaterContent = {
  "200": "#FCC09C",
  "500": "#CB5105",
  "800": "#692A02"
};
var solarRadiation = {
  "200": "#FAFA9E",
  "500": "#CBCB0B",
  "800": "#838307"
};
var airTemperature = {
  "200": "#FEE7B4",
  "500": "#FBAF05",
  "800": "#B07A03"
};
var wetTemperature = {
  "200": "#D1DDF9",
  "500": "#5E88EC",
  "800": "#1B56E4"
};
var dryTemperature = {
  "200": "#9DECDF",
  "500": "#23B19B",
  "800": "#177365"
};
var soilTemperature = {
  "200": "#D9C6BF",
  "500": "#795548",
  "800": "#484646"
};
var dewTemperature = {
  "200": "#D7E8F4",
  "500": "#72B0D8",
  "800": "#378FC8"
};
var wind = {
  "200": "#E1E1E1",
  "300": "#B8B8B8",
  "400": "#999999",
  "500": "#616161",
  "600": "#525252",
  "700": "#424242",
  "800": "#343"
};
var vaporPressureDeficit = {
  "200": "#E7ACEC",
  "500": "#C03FCB",
  "800": "#751C7D"
};
var metrics = {
  CAPA: capacitive,
  // Hydric potential
  CLDC: unassigned,
  // Cloud coverage
  COLD_T_HOUR: wetTemperature,
  // number of hours cold,
  DD: wind,
  // Wind Direction
  DRN: drainage,
  // Drainage
  DXY: wind,
  // Wind gusts Direction
  ECP: electroConductivity,
  // EC
  etp: evapotranspiration,
  FF: wind,
  // Average wind speed
  FXY: wind,
  // Max wind gusts speed
  HDEF: hydricDeficit,
  // Hydric potential
  heatAccumulation: airTemperature,
  // Heat accumulation
  HPOT: hydricPotential,
  // Hydric potential
  IRR: irrigation,
  // Irrigation
  LW_D: leafWetness,
  // Leaf Wetness Duration
  LW_V: leafWetness,
  // Leaf Wetness
  PPFD_MAX: photosyntheticActiveRadiation,
  // Maximum Photosynthetic Active Radiation
  PPFD_MIN: photosyntheticActiveRadiation,
  // Minimum Photosynthetic Active Radiation
  PPFD: photosyntheticActiveRadiation,
  // Photosynthetic Active Radiation
  rainfallIntensity: rainfalls,
  // Rainfall intensity
  RR: rainfalls,
  // Rainfalls
  RRAccumulation: rainfalls,
  // Rainfalls accumulation
  SSI_HOURS: solarRadiation,
  // Hours of sunlight
  SSI_HOURSAccumulation: solarRadiation,
  // Cumulative sunlight hours
  SSI_MAX: solarRadiation,
  // Maximum Solar radiations
  SSI_MIN: solarRadiation,
  // Minimum Solar radiations
  SSI: solarRadiation,
  // Solar radiations
  SWC: soilWaterContent,
  // Water content, calculated via permittivity measured at a single point
  T_CAL: soilTemperature,
  // CHP calibration temperature
  T_CAPA: soilTemperature,
  // capacitive sensor temperature
  T_DEW: dewTemperature,
  // dew point temperature
  T_DRY: dryTemperature,
  // Dry temperature
  T_SOIL: soilTemperature,
  // Soil temperature
  T_WET: wetTemperature,
  // Wet temperature
  T: airTemperature,
  // Air temperature
  TN: airTemperature,
  // Min air temperature
  TX: airTemperature,
  // Max air temperature
  U_CAPA: capacitive,
  // Hydric potential
  U: humidity,
  // Air humidity
  UN: humidity,
  // min air humidity
  UX: humidity,
  // max air humidity
  VOLT: unassigned,
  // metric not used right now so black to avoid typescript error
  VPD: vaporPressureDeficit
};
var metrics_default = metrics;

// src/themes/light/colors.ts
var primary200 = "#CCE3ED";
var primary500 = "#0172A4";
var primary800 = "#013C56";
var colors = {
  grayscale: {
    white: "#FFFFFF",
    "50": "#FAFBFC",
    "100": "#E6EAEB",
    "200": "#CCD4D7",
    "300": "#B3BEC3",
    "400": "#99A8AE",
    "500": "#7F9299",
    "600": "#667D86",
    "700": "#4D6872",
    "800": "#33515D",
    "900": "#1A3C4A",
    black: "#002635"
  },
  primary: {
    "200": primary200,
    "300": "#83C5E2",
    "400": "#0194D5",
    "500": primary500,
    "600": "#015F89",
    "700": "#014D6F",
    "800": primary800
  },
  secondary: {
    "200": "#F8EC6A",
    "300": "#FADF55",
    "400": "#F7C84C",
    "500": "#FF8500",
    "600": "#CC6A00",
    "700": "#995000",
    "800": "#663500"
  },
  tertiary: {
    "200": "#BCE7ED",
    "500": "#01ADBE",
    "800": "#015860"
  },
  // Brand & Plans
  plans: {
    essential: {
      "200": "#E2E0FD",
      "500": "#6F66F7",
      "800": "#140AB8"
    },
    plus: {
      "200": "#CCF1EB",
      "500": "#01B99D",
      "800": "#0D7767"
    },
    expert: {
      "200": primary200,
      "500": primary500,
      "800": primary800
    }
  },
  // Data scale
  data: {
    protected: "#6F66F7",
    perfect: "#6CC68F",
    good: "#B5E3C7",
    correct: "#FFE599",
    average: "#FFC34C",
    warn: "#FFA54C",
    bad: "#FC7E7E",
    danger: "#F20D0D"
  },
  // Feedback
  feedback: {
    success: {
      "200": "#D1EBDD",
      "500": "#24B066",
      "800": "#055E2F"
    },
    warning: {
      "200": "#FFE6AE",
      "500": "#FBAF05",
      "800": "#624400"
    },
    error: {
      "200": "#FFC4C4",
      "500": "#E05252",
      "800": "#661515"
    }
  },
  depths: {
    "5": "#9404F8",
    "10": "#105200",
    "15": "#8BBF0D",
    "20": "#8C5E82",
    "25": "#E4B613",
    "30": "#46DA82",
    "35": "#0E86DE",
    "40": "#949494",
    "45": "#DF0000",
    "50": "#870021",
    "55": "#0A1DC6",
    "60": "#F608C2",
    "65": "#35390C",
    "70": "#FECC1A",
    "75": "#000000",
    "80": "#00B1C9",
    "85": "#6A4600",
    "90": "#B14C19"
  },
  dss: {
    irrelis: "#116967"
  },
  metrics: metrics_default
};
var colors_default = colors;

// src/themes/light/index.ts
var lightTheme = new Theme({
  name: "light",
  colors: colors_default,
  typography: typography_default,
  shadows: shadows_default,
  spacings: spacings_default,
  radiuses: radiuses_default,
  borderWidths: borderWidths_default
});
var light_default = lightTheme;

// src/themes/dark/colors.ts
var colors_default2 = colors_default;

// src/themes/dark/index.ts
var darkTheme = new Theme({
  name: "dark",
  colors: colors_default2,
  typography: typography_default,
  shadows: shadows_default,
  spacings: spacings_default,
  radiuses: radiuses_default,
  borderWidths: borderWidths_default
});
var dark_default = darkTheme;

// src/themes/index.ts
var themes_default = {
  light: light_default,
  dark: dark_default,
  shared: shared_exports
};

// src/tokens.ts
function isRadiusToken(input) {
  return Object.keys(radiuses_default).includes(input);
}
function isBorderWidthToken(input) {
  return Object.keys(borderWidths_default).includes(input);
}
function isFontSizeToken(input) {
  return Object.keys(typography_default.sizes).includes(input);
}
function isSpacingToken(input) {
  return Object.keys(spacings_default).includes(input);
}

// src/utils.ts
function flattenObject(obj) {
  const toReturn = {};
  for (const parentKey in obj) {
    if (!(parentKey in obj)) continue;
    if (typeof obj[parentKey] == "object" && obj[parentKey] !== null) {
      const flatObject = flattenObject(obj[parentKey]);
      for (const childKey in flatObject) {
        if (!(childKey in flatObject)) continue;
        toReturn[parentKey + "." + childKey] = flatObject[childKey];
      }
    } else {
      toReturn[parentKey] = obj[parentKey];
    }
  }
  return toReturn;
}
var flatColors = flattenObject(colors_default);
function fromColorPathToColor(path) {
  return path in flatColors ? flatColors[path] : path;
}
export {
  Theme,
  fromColorPathToColor,
  isBorderWidthToken,
  isFontSizeToken,
  isRadiusToken,
  isSpacingToken,
  themes_default as themes
};
